/**
 * A QR code of `text`, black on white with the margin scanners need (core/qr.ts, its encoder
 * loaded the first time). Small; a tap shows it big, for a camera across the table, and back.
 */
import { useEffect, useState, type JSX } from 'react';

import { qrDrawing, type QrDrawing } from '@core/qr';

import './qr.css';

/** White squares around the code: scanners need a quiet margin. */
const QUIET = 2;

export function QrCode({ text, label }: { text: string; label: string }): JSX.Element {
  const [qr, setQr] = useState<{ text: string; drawing: QrDrawing } | null>(null);
  const [big, setBig] = useState(false);
  useEffect(() => {
    let live = true;
    void qrDrawing(text).then((drawing) => {
      if (live) setQr({ text, drawing });
    });
    return () => {
      live = false;
    };
  }, [text]);
  const drawing = qr?.text === text ? qr.drawing : null;
  const span = (drawing?.size ?? 21) + QUIET * 2;
  return (
    <button
      type="button"
      className={`qr${big ? ' big' : ''}`}
      aria-label={label}
      aria-pressed={big}
      onClick={() => setBig(!big)}
    >
      <svg viewBox={`${String(-QUIET)} ${String(-QUIET)} ${String(span)} ${String(span)}`}>
        {drawing && <path d={drawing.path} />}
      </svg>
    </button>
  );
}
